import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import GreenRatingStar from '../../public/images/GreenRating.svg';
import GreyRatingStar from '../../public/images/GreyRating.svg';
import MentionedIn from '../../public/images/mentioned-in.svg';

import { logAmplitude } from '../../utils/amplitude';
import TrustMarkCarousel from '../trustmark-carousel';

const Image = styled.img`
  left: 0;
  max-width: 100%;
  opacity: 1;
  top: 0;
  height: auto;
  margin-bottom: 0.25rem;
`;

const RatingWrapper = styled.div`
  display: flex;
  margin: auto;
  gap: 0.4rem;
`;

const TrustMarkWrapper = styled.div`
  margin: 2.8rem -${({ theme }) => theme.modularScale.thirty} 0 -${({ theme }) => theme.modularScale.thirty};
  background-color: #f4f4f6;
`;

const TrustPilot = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  padding-top: 1.25rem;
`;

const Link = styled.a`
  text-decoration: none;
  color: black;
  margin-right: 1.8rem;
`;

const TrustPilotWrapper = styled.div`
  text-align: center;
  padding-bottom: 2rem;
`;

const Rating = styled.span`
  margin-left: 4px;
  font-family: 'GT Walsheim Web';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
`;

const ReviewsCount = styled.div`
  font-family: 'GT Walsheim Web';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #75757c;
  margin-top: 4px;
`;

const MentionedWrapper = styled.div`
  height: 80px;
  overflow: hidden;
  margin: 0.8rem 1.6rem 0 1.6rem;
  background-color: white;
  display: flex;
  justify-content: center;
`;

function TrustMark(props) {
  const onTrustPilotClick = () => {
    logAmplitude('PDP Interaction', {
      product: props.product,
      interactionType: 'clicked Trustpilot',
      image: props.product.master?.images[0]?.product_url
    });
  };

  const linkProps = {
    target: '_blank',
    href: 'https://www.trustpilot.com/review/maisonette.com',
    rel: 'noopener noreferrer'
  };

  return (
    <TrustMarkWrapper>
      <TrustPilotWrapper>
        <TrustPilot>
          <Link {...linkProps} onClick={onTrustPilotClick}>
            <Image src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/images/Trustpilot.png`}></Image>
          </Link>
          <Link {...linkProps} onClick={onTrustPilotClick}>
            <RatingWrapper>
              <GreenRatingStar></GreenRatingStar>
              <GreenRatingStar></GreenRatingStar>
              <GreenRatingStar></GreenRatingStar>
              <GreenRatingStar></GreenRatingStar>
              <GreyRatingStar></GreyRatingStar>
              <Rating>4.0</Rating>
            </RatingWrapper>
          </Link>
          <Link {...linkProps} onClick={onTrustPilotClick}>
            <ReviewsCount>200+ reviews</ReviewsCount>
          </Link>
        </TrustPilot>

        <TrustMarkCarousel product={props.product}></TrustMarkCarousel>

        <MentionedWrapper>
          <MentionedIn></MentionedIn>
        </MentionedWrapper>
      </TrustPilotWrapper>
    </TrustMarkWrapper>
  );
}

TrustMark.propTypes = {
  product: PropTypes.object.isRequired
};

export default TrustMark;
